import React from 'react';
import PropTypes from 'prop-types';
import {
    AuthContext,
    AlertContext,
    ServicesProvider,
    AlertProvider,
    AuthProvider,
    ClientContext,
    ClientProvider,
    CacheApiProvider,
} from '~/services';

const propTypes = {
    mainRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.elementType }),
    ]).isRequired,
    children: PropTypes.node.isRequired,
};

function ContextProviders(props) {
    return (
        <AlertProvider>
            <AlertContext.Consumer>
                {(alert) => (
                    <AuthProvider dismissBanners={alert.dismissAllBanners}>
                        <AuthContext.Consumer>
                            {(auth) => (
                                <ClientProvider>
                                    <ClientContext.Consumer>
                                        {(client) => (
                                            <ServicesProvider
                                                auth={auth}
                                                alert={alert}
                                                client={client}
                                                mainRef={props.mainRef}
                                            >
                                                <CacheApiProvider>
                                                    {props.children}
                                                </CacheApiProvider>
                                            </ServicesProvider>
                                        )}
                                    </ClientContext.Consumer>
                                </ClientProvider>
                            )}
                        </AuthContext.Consumer>
                    </AuthProvider>
                )}
            </AlertContext.Consumer>
        </AlertProvider>
    );
}

ContextProviders.propTypes = propTypes;

export { ContextProviders };
